// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file auth/switch_context.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Level } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.SwitchContextRequest
 */
export class SwitchContextRequest extends Message<SwitchContextRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: com.neulink.pharmacy.Level level = 2;
   */
  level = Level.UNSPECIFIED;

  constructor(data?: PartialMessage<SwitchContextRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SwitchContextRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "level", kind: "enum", T: proto3.getEnumType(Level) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SwitchContextRequest {
    return new SwitchContextRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SwitchContextRequest {
    return new SwitchContextRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SwitchContextRequest {
    return new SwitchContextRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SwitchContextRequest | PlainMessage<SwitchContextRequest> | undefined, b: SwitchContextRequest | PlainMessage<SwitchContextRequest> | undefined): boolean {
    return proto3.util.equals(SwitchContextRequest, a, b);
  }
}

